import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withPrefix } from 'gatsby';

import { prop } from 'src/utils';

const getMetaTitle = prop('metaTitle');
const getMetaDescription = prop('metaDescription');

const rtlLangs = ['ar', 'fa', 'ur', 'he'];

export function SEO({ lang, title, description, metadata, bodyClassName }) {
  const metaTitle = getMetaTitle(metadata);
  const metaDescription = description || getMetaDescription(metadata);

  return (
    <Helmet
      htmlAttributes={{
        lang,
        dir: rtlLangs.includes(lang) ? 'rtl' : 'ltr',
      }}
      title={title}
      titleTemplate={`%s | ${metaTitle}`}
      defaultTitle={metaTitle}
    >
      {/* <link rel="shortcut icon" type="image/ico" href={favicon} /> */}
      {/* <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} /> */}
      {/* <link rel="icon" type="image/png" sizes="32x32" href={favicon32} /> */}
      {/* <link rel="icon" type="image/png" sizes="16x16" href={favicon16} /> */}
      <meta name="msapplication-TileColor" content="#FFFFFF" />
      <meta name="theme-color" content="#FFFFFF" />
      <meta name="description" content={metaDescription} />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:type" content="website" />
      <meta name="og:url" content="/" />
      <meta name="og:image" content={`${withPrefix('/')}img/og-image.jpg`} />
      <meta name="twitter:card" content="summary" />
      {/* <meta name="twitter:creator" content={siteMetadata.author} /> */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <body className={`font-${lang} ${bodyClassName}`} />
    </Helmet>
  );
}

SEO.propTypes = {
  lang: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  metadata: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  bodyClassName: PropTypes.string,
};

SEO.defaultProps = {
  lang: 'en',
  title: null,
  description: null,
  metadata: null,
  bodyClassName: null,
};
